module.exports = __webpack_public_path__ + "img/return-dispatch-icon.918a3f17.svg";